<template>
  <question-base-wrapper
    :help-text="questionHelpText"
    :question-id="questionId"
    :title="title || 'Phone number'"
    :subtitle="subtitle || 'Please provide the number to best contact you on, landline or mobile'"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ errors, failedRules, validate }"
      :vid="`${stepId}_telephone`"
      slim
      name="Telephone"
      :rules="rules"
      mode="passive"
    >
      <qz-text-field
        v-model="questionData[questionFields.telephone]"
        :data-test="fieldTrackerId"
        :error-messages="getFieldErrors('telephone', failedRules, errors)"
        :maxlength="phoneNumberLimit"
        :class="!isColumnLayout && 'mt-6'"
        type="tel"
        autocomplete="tel"
        @keyup="helpers.limitInputChars(questionData, questionFields.telephone, phoneNumberLimit)"
        @change="validate()"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-telephone',
  extends: QuestionBase,
  inject: [
    'constants',
    'config',
  ],
  data () {
    return {
      fields: ['telephone'],
    };
  },
  computed: {
    questionHelpText () {
      if (this.helpText?.value) return this.helpText;
      const shortHelpText = `<strong>Why do I need to enter a phone number?</strong>
          <br>
          Your insurance provider may need to contact you to discuss your policy.`;
      if (this.constants.PARTNERS.Apricot.includes(this.config.partner)) return shortHelpText;

      const defaultHelpText = shortHelpText + ' Later in this form we’ll also ask you if you want to share your number with the providers who offer you the lowest prices, to discuss your insurance needs before you buy (this is a free service and completely optional).';

      const helpText = {
        value: typeof this.helpText === 'string' ? this.helpText : defaultHelpText,
        fullWidth: this.isColumnLayout,
      };
      return helpText;
    },
    rules () {
      const rules = this.validationRules && this.validationRules[this.questionFields.telephone];
      return rules || 'telephone:10,12';
    },
    phoneNumberLimit () {
      // Property need to prevent input character collapsing
      const limit = this.inputCharsLimiters.TELEPHONE;
      if (!this.questionData.telephone) return limit - 1;
      return this.questionData.telephone.indexOf('+44') === 0 ? limit + 2 : limit;
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.telephone);
    },
  },
};
</script>
